const cross = (a, b, c) => (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
export function validPolygon(points) {
  if (!Array.isArray(points) || points.length < 3 || points.length > 200 ||
      points.some((p) => !Number.isFinite(p.x) || !Number.isFinite(p.y))) return false;
  const n = points.length;
  if (points.some((p, i) => Math.hypot(p.x - points[(i + 1) % n].x, p.y - points[(i + 1) % n].y) < 1e-5)) return false;
  for (let i = 0; i < n; i += 1) for (let j = i + 1; j < n; j += 1) {
    if (j === i + 1 || (i === 0 && j === n - 1)) continue;
    const a = points[i], b = points[(i + 1) % n], c = points[j], d = points[(j + 1) % n];
    if (cross(a, b, c) * cross(a, b, d) <= 0 && cross(c, d, a) * cross(c, d, b) <= 0 &&
        Math.max(Math.min(a.x, b.x), Math.min(c.x, d.x)) <= Math.min(Math.max(a.x, b.x), Math.max(c.x, d.x)) &&
        Math.max(Math.min(a.y, b.y), Math.min(c.y, d.y)) <= Math.min(Math.max(a.y, b.y), Math.max(c.y, d.y))) return false;
  }
  return Math.abs(points.reduce((s, p, i) => s + p.x * points[(i + 1) % n].y - points[(i + 1) % n].x * p.y, 0)) > 1e-6;
}

/** Ear clipping supports concave surveyed footprints without filling courtyards. */
export function triangulate(points) {
  if (!validPolygon(points)) return [];
  const ids = points.map((_, i) => i), triangles = [];
  const area = points.reduce((s, p, i) => s + p.x * points[(i + 1) % points.length].y - points[(i + 1) % points.length].x * p.y, 0);
  if (area < 0) ids.reverse();
  while (ids.length > 3) {
    let found = false;
    for (let i = 0; i < ids.length; i += 1) {
      const a = ids[(i + ids.length - 1) % ids.length], b = ids[i], c = ids[(i + 1) % ids.length];
      if (cross(points[a], points[b], points[c]) <= 1e-10) continue;
      if (ids.some((k) => k !== a && k !== b && k !== c &&
          cross(points[a], points[b], points[k]) >= 0 && cross(points[b], points[c], points[k]) >= 0 && cross(points[c], points[a], points[k]) >= 0)) continue;
      triangles.push([a, b, c]); ids.splice(i, 1); found = true; break;
    }
    if (!found) return [];
  }
  triangles.push(ids);
  return triangles;
}
